import { render, staticRenderFns } from "./panelTitle.vue?vue&type=template&id=2fb8f490&scoped=true"
import script from "./panelTitle.vue?vue&type=script&lang=js"
export * from "./panelTitle.vue?vue&type=script&lang=js"
import style0 from "./panelTitle.vue?vue&type=style&index=0&id=2fb8f490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb8f490",
  null
  
)

export default component.exports